import styled from '@xstyled/styled-components';

export const Select = styled.div`
  background-color: greyLight;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s all linear;

  &:hover {
    background-color: greyMed;
  }

  svg {
    width: 15px;

    path {
      fill: #000000;
    }
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: sm;
  color: black;

  span {
    font-size: xs;
    color: greyDark;
  }
`;

export const ModalBlock = styled.div`
  display: flex;
  background-color: white;
  position: relative;
  border-radius: 10px;

  @media (max-width: sm) {
    width: 100%;
  }
`;
